document.addEventListener('DOMContentLoaded', function () {

  const button = document.querySelector('.eid-hamburger');
  const nav = document.getElementById('eidMobileNav');

  if (!button || !nav) {
    return;
  }


  function openMenu() {
    nav.classList.add('is-open');
    button.classList.add('is-open');

    button.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
  }


  function closeMenu() {
    nav.classList.remove('is-open');
    button.classList.remove('is-open');

    button.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
  }


  function toggleMenu() {

    if (nav.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }

  }


  /* ハンバーガーボタン */
  button.addEventListener('click', function (event) {

    event.stopPropagation();

    toggleMenu();

  });


  /* メニュー内リンク */
  nav.querySelectorAll('a').forEach(function (link) {

    link.addEventListener('click', function () {
      closeMenu();
    });

  });


  /* メニュー外をクリック */
  document.addEventListener('click', function (event) {

    if (
      nav.classList.contains('is-open') &&
      !nav.contains(event.target) &&
      !button.contains(event.target)
    ) {
      closeMenu();
    }

  });


  /* Escapeキー */
  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      nav.classList.contains('is-open')
    ) {
      closeMenu();
    }

  });


  /* PC幅に戻った場合 */
  window.addEventListener('resize', function () {

    if (window.innerWidth > 1024) {
      closeMenu();
    }

  });

});